import React, {lazy, Suspense} from 'react';
import {createBrowserRouter, redirect, RouterProvider} from 'react-router-dom';
import Loading from 'components/loading';
import MainLayout from 'components/main-layout';
import AuthLayout from 'features/auth/components/auth-layout';

const LoginPage = lazy(() => import('pages/login'));
const RegisterPage = lazy(() => import('pages/register'));
const ForgotPasswordPage = lazy(() => import('pages/forgot-password'));
const ResetPasswordPage = lazy(() => import('pages/reset-password'));
const HomePage = lazy(() => import('pages/home'));
const ProfilePage = lazy(() => import('pages/profile'));


const redirectToLogin = async (route, visibleForGuest=false) => {
  const authorized = sessionStorage.getItem('authorized');
  const isGuest = sessionStorage.getItem('isGuest');
  
  const redirectToLoginPage = !authorized && (!isGuest || !visibleForGuest);
  if (redirectToLoginPage) {
    return redirect('/login');
  }
};

const redirectIfUser = async () => {
  const authorized = sessionStorage.getItem('authorized');
  if (authorized) {
    return redirect('/');
  }
};

const router = createBrowserRouter([
  {
    element: <MainLayout />,
    children: [
      {
        path: '/',
        element: <HomePage/>,
        loader: route => redirectToLogin(route, true),
      },
      {
        path: '/settings/profile',
        element: <ProfilePage/>,
        loader: redirectToLogin,
      },
    ],
  },
  {
    element: <AuthLayout />,
    children: [
      {
        path: '/login',
        element: <LoginPage/>,
        loader: redirectIfUser,
      },
      {
        path: '/register',
        element: <RegisterPage/>,
        loader: redirectIfUser,
      },
      {
        path: '/forgot-password',
        element: <ForgotPasswordPage/>,
        loader: redirectIfUser,
      },
      {
        path: '/reset-password',
        element: <ResetPasswordPage/>,
        loader: redirectIfUser,
      },
    ],
  },
]);

//TODO - Investigating why HMR does nto work here
if (import.meta.hot) {
  // import.meta.hot.dispose(() => router.dispose());
}

const App = () => {
  return (
    <Suspense fallback={<Loading />}>
      <RouterProvider router={router} />
    </Suspense>
  );
};

export default App;
